<template>
    <div>
        <fieldset>
            <div id="pudo-points-preloader" class="div-preloader"><div class="div-status"></div></div>
            <legend><strong>{{ _t('Search BRT PUDO') }}</strong></legend>
            <div class="row">
                <div class="col-md-5 form-group" :class="{'has-error': hasPostalCodeError }">
                    <label class="control-label">{{ _t('postal_code-form-label') }}*</label>
                    <input type="text" class="form-control" v-model="postalCode" :disabled="searchDisabled">
                </div>
                <div class="col-md-5 form-group"  :class="{'has-error': hasCityError }">
                    <label class="control-label">{{ _t('city-form-label') }}*</label>
                    <input type="text" class="form-control" v-model="city" :disabled="searchDisabled">
                </div>
                <div class="col-md-2">
                    <label class="control-label">&nbsp;</label>
                    <a href="#" class="btn btn-success form-control" @click.prevent="search">{{ _t('Search') }}</a>
                </div>
            </div>
            <div class="row" v-show="points.length">
                <div class="col-md-12" style="max-height: 400px; overflow: auto;">
                    <table class="table" style="background: white; margin-bottom: 0px; margin-top: 15px;">
                        <tbody>
                            <tr>
                                <th style="white-space: nowrap; position: sticky; top: 0; background: white;">{{ _t('distance-form-label') }}</th>
                                <th style="white-space: nowrap; position: sticky; top: 0; background: white;">{{ _t('name-form-label') }}</th>
                                <th style="white-space: nowrap; position: sticky; top: 0; background: white;">{{ _t('pudo_id-form-label') }}</th>
                                <th style="white-space: nowrap; position: sticky; top: 0; background: white;">{{ _t('address-form-label') }}</th>
                                <th style="white-space: nowrap; position: sticky; top: 0; background: white;"></th>
                            </tr>
                            <tr v-for="(point, index) in points">
                                <td>{{ point.distanceFromPoint / 1000 }} Km</td>
                                <td>{{ point.pointName }}</td>
                                <td>{{ point.pudoId }}</td>
                                <td>{{ point.fullAddress }}</td>
                                <td class="text-right"><a href="#" class="btn btn-success" @click.prevent="selectPoint(point)">{{ _t('Select') }}</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-show="noResults">
                <div class="col-md-12">
                    <p class="text-center"><b>{{ _t('No results found.') }}</b></p>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: [
            'brtPudoRoute',
        ],
        data() {
            return {
                postalCode: null,
                hasPostalCodeError: false,
                city: null,
                hasCityError: false,
                address: null,
                points: [],
                noResults: false,
                searchDisabled: false,
            }
        },
        created: function() {

        },
        mounted: function() {
            let _class = this;
            $(function () {
                if (!$('#shipping_type').is(':disabled')) {
                    _class.setReadonlyAttr($('#shipping_type').val());
                } else {
                    _class.searchDisabled = true;
                }
                $('#shipping_type').change(function () {
                    _class.setReadonlyAttr($(this).val());
                });
            });
        },
        methods: {
            search() {
                if (this.searchDisabled) {
                    return ;
                }
                if (!this.isValidSearchForm()) {
                    return ;
                }

                $('#pudo-points-preloader').show();
                this.noResults = false;
                let _class = this;

                axios.get(this.brtPudoRoute, {
                    params: {
                        zipCode: this.postalCode,
                        city: this.city
                    }
                })
                    .then(function (response) {
                        _class.points = response.data.data;
                        if (_class.points.length == 0) {
                            _class.noResults = true;
                        }
                        $('#pudo-points-preloader').hide();
                    })
                    .catch(function (error) {
                        $('#pudo-points-preloader').hide();
                        _class.noResults = true;
                        console.log(error);
                    })
            },
            isValidSearchForm() {
                this.hasPostalCodeError = (this.postalCode == null) ? true : false;
                this.hasCityError = (this.city == null) ? true : false
                if (this.hasPostalCodeError || this.hasCityError) {
                    return false;
                }
                return true;
            },
            selectPoint(point) {
                let _class = this;
                Swal.fire({
                    text: _t('Are you sure?'),
                    icon: "warning",
                    buttonsStyling: false,
                    showCancelButton: true,
                    cancelButtonText: _t('No'),
                    confirmButtonText: _t('Yes'),
                    customClass: {
                        confirmButton: 'btn btn-success',
                        cancelButton: 'btn btn-default',
                    }
                }).then(function (result) {
                    if (result.value) {
                        Event.$emit('shippingBrtPudoUpdated', {
                            shippingAddress: point.street + ' ' + point.streetNumber,
                            shippingBrtPudoName: point.pointName,
                            shippingBrtPudoId: point.pudoId,
                            shippingPostalCode: point.zipCode
                        });
                        $('#shipping_address').val(point.street + ' ' + point.streetNumber);
                        $('#shipping_brt_pudo_name').val(point.pointName);
                        $('#shipping_brt_pudo_id').val(point.pudoId);
                        $('#shipping_postal_code').val(point.zipCode);
                        $('#shipping_city').html('<option value="' + point.town + '">' + point.town + '</option>');
                        $('#shipping_province').html('<option value="' + point.state + '">' + point.state + '</option>');
                        _class.points = [];
                        _class.postalCode = '';
                        _class.city = '';
                    }
                });
            },
            setReadonlyAttr(shippingType) {
                if (shippingType == 'brt_pudo') {
                    $('#shipping_address').attr('readonly', 'readonly');
                    $('#shipping_brt_pudo_name').attr('readonly', 'readonly');
                    $('#shipping_brt_pudo_id').attr('readonly', 'readonly');
                    $('#shipping_postal_code').attr('readonly', 'readonly');
                    $('#shipping_city').attr('readonly', 'readonly');
                    $('#shipping_province').attr('readonly', 'readonly');
                } else {
                    $('#shipping_address').removeAttr('readonly');
                    $('#shipping_brt_pudo_name').removeAttr('readonly');
                    $('#shipping_brt_pudo_id').removeAttr('readonly');
                    $('#shipping_postal_code').removeAttr('readonly');
                    $('#shipping_city').removeAttr('readonly');
                    $('#shipping_province').removeAttr('readonly');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/shippingBrtPudo.vue